<template>
 <div> {{ActDescBtn}}
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
   <tr max-height="48px" height="48px">   

<ContenidoBase 
  :titulo="'Utilitario Devolucion'"
  :descripcion="'Utilitario Devolucion'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"  
/>
    </tr>
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitBancos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <div class="px-2" >
  <v-card color="grey lighten-3">
    <div class="px-2" >
  <v-form ref="formDevolucion" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>

<!-- columna 1 -->
<v-col cols="12" md="6" sm="6" >

  <!-- -----------------------------  fechaInicial  -->
<v-text-field
        class="fontSize12 pb-2"
        dense
        outlined
        type="date"  
        label="Fecha Desde"
         :rules="[$rules.required]"
        v-model="busquedaDevolucion.fechaInicial"
        hide-details
        @blur="BlurDesde"
        @input="getDevolucion"
        v-on:input="resertPaginacion"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>

 <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <!-- Factura No --------------------------------------------------->
                          <v-text-field
                            hide-details
                            class="fontSize12 pb-2"
                            v-on="on"
                            label="No.Dec:"
                            autocomplete="off"
                            dense
                            outlined
                            v-model.number="busquedaDevolucion.NoDevolucion"
                            @keyup="KeyUpCantidad"
                            placeholder=" "
                            style="font-size: 12px"
                            @input="getDevolucion"
                            v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-slack"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se registra el número de factura de venta que se desea buscar.</span>
                        </i>
 </v-tooltip>

<v-text-field
                        label="NCF"
                        autocomplete="off"
                        dense
                        outlined
                        v-model="busquedaDevolucion.ncf"
                        @blur="getDevolucion"
                        v-on:blur="resertPaginacion"
                        hide-details
                            class="fontSize12"
                      >
                        <template v-slot:prepend>
                          <i style="font-size: 20px" class="fa fa-barcode"></i>
                        </template>
                      </v-text-field>

</v-col>
<!-- fn columna 1 -->
<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">
  <!-- -----------------------------  fechaInicial  -->
<v-text-field
        class="fontSize12 pb-2"
        dense
        outlined
        type="date"  
        label="Fecha Hasta"
         :rules="[$rules.required]"
        v-model="busquedaDevolucion.fechaFinal"
        hide-details
        @blur="BlurHasta"
         @input="getDevolucion"
        v-on:input="resertPaginacion"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>

  <v-col cols="12" md="12" sm="12" class="pt-0 mt-0">
    <center>
<!-- class="pa-0 ma-0 py-0 my-0" :class="`d-flex justify-center white--text`"-->
  <!-- <v-row no-gutters></v-row> -->
  <span style="font-size: 12px"><b>OPCION FAC. ELECTRÓNICO:</b><!-- <span style="color: #C62828;"> Para </span> --> </span>
<v-radio-group dense @change="getDevolucion"  hide-details class="pt-0 mt-0 d-flex justify-center "  v-model="busquedaDevolucion.opcion" row>     
                  <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                  <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                  <v-radio  label="" color="green" :value="0">
                    <template v-slot:label>
                      <strong style="color: #000000; font-size: 11px">TODOS</strong>
                    </template>
                  </v-radio>
                  <v-radio  label="" color="green" :value="1">
                    <template v-slot:label>
                      <strong style="color: #000000; font-size: 11px">NO ENVIADA</strong>
                    </template>
                  </v-radio>

                  <v-radio  label="" color="green" :value="2">
                    <template v-slot:label>
                      <strong style="color: #000000; font-size: 11px">ENVIADA</strong>
                    </template>
                  </v-radio>
                                                          
                  
</v-radio-group>
<v-text-field class="pt-0 mt-0 fontSize12" hide-details v-if="busquedaDevolucion.opcion==2"  autocomplete="off"  v-model="busquedaDevolucion.buscarTrackId" 
               label="" dense single-line  style="border:1px solid #000000;"
               @blur="getDevolucion">
              <template v-slot:prepend-inner>
                <i style="font-size: 20px;" class="fa fa-search"></i>
              </template>
              <template v-slot:label>
                <!-- <strong style="color: #000000; font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</strong> -->
                <span style="font-size: 11px" >BUSCAR CON REF:(Aceptado/Rechazado)</span>
              </template>
            </v-text-field>
</center>

 </v-col>

</v-col>
<!-- fn columna 2 -->

 </v-row>
</v-form>
<v-col cols="12" md="12" sm="12">
 <div style="border: 1px solid #000000;" >
<v-data-table
      class="RowSelectColor elevation-1 RowSelectColor TbSize12"
      :single-select="true"
      :show-select="true"
       item-key="indx"
       v-model="selected"
       @item-selected="obtenerDatoSelect"
       :footer-props="$arrayPropiedasesGlobal"
      :headers="[
                 { text: 'FECHA', sortable: false, value: 'nuevaFecha', width:120, class: ['no-gutters black--text']  },
                 { text: 'DOCUMENTO', sortable: false, value: 'documentoinventario.descripcion', width:'auto', class: ['no-gutters black--text']  },
                 { text: '# DEV', sortable: false, value: 'devoclucionPK.secuencia', width:129, class: ['no-gutters black--text']  },
                 { text: 'NCF', sortable: false, value: 'ncf', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'CLIENTE', sortable: false, value: 'nombre', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'VALOR', sortable: false, value: 'valor', width:'auto', class: ['no-gutters black--text'] },
                 ]"
              dense
              :items="listDatos"  
              :search="search"
              @click:row="datostabla"
              @pagination="cargarPaginacion"
              :items-per-page="paginator.itemsPerPage"
              :server-items-length="TotalRegistros"
            >


<template v-slot:item.valor="props">
    <span>{{currencyFormatter(props.item.valor )}}</span>
</template>


<template v-slot:item.nuevaFecha="props">
                <span style="font-size:12px; display:none;">{{props.item.indx = listDatos.indexOf(props.item)}}</span>
                <span style="font-size:12px;" >{{ FormatoFecha(props.item.nuevaFecha) }}</span>
 </template>

<template v-slot:item.nombre="props">
    <span v-if="props.item.facturasventa.hasOwnProperty('nombreDgii') && props.item.facturasventa.nombreDgii!=null"> {{props.item.facturasventa.nombreDgii.trim() }}</span>
</template>



<!-- <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:15px; color: #00838F;">Total:</strong></td>                                                                               
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
 
 </tr>
 </template>

 <template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>Total Meta de Ventas:0.00</span>
        <span>Total Ventas:0.00</span>
        <span>Total % Comisión:0.00</span>
       <span>Valor Comisiones:0.00</span>
      </v-list-item-content>
</v-list-item>

  </template> -->
</v-data-table>
 </div>
</v-col>
      
    </div>
  </v-card>

 </div>
<hr />
<v-card color="grey lighten-3" v-if="UtilDevolucion!=null"> 
  <div class="px-2 pt-1" style="border: 1px solid #000000">
             <!-- DEVOLUCION Electronica -->
              <v-col v-if="activarModuloEletronica(UtilDevolucion)==true" class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;" cols="12" md="12" sm="12">
               <v-card>
                <v-col style="background-color:#BDBDBD;" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                                 <span><b>Devolución Electrónica</b></span>
                 </v-col>

                 <!-- cuerpo FACTURACION ELETRONICA -->
                  <v-col cols="12" md="12" sm="12">
                    <v-row>
                      <v-col cols="12" md="4" sm="4" class="py-0 my-0">
                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">  
                                              
                                                 <v-btn @click.prevent="DevolucionEletronicaGet(UtilDevolucion)" v-on="on" color="blue" outlined  small dark>
                                                <i style="font-size: 20px;" class="fa fa-plus-square"></i> ACTUALIZAR DEV.ElETRONICO
                                                </v-btn>

                                                </template>
                                                      <span>ACTUALIZAR DEV.ElETRONICO</span>
                                                </v-tooltip> 
                      </v-col>

                      <v-col cols="12" md="4" sm="4" class="py-0 my-0"> 
                                        <v-text-field id="formdisabledInput" disabled style="font-size:13px;" hide-details
                                        :value="UtilDevolucion.signatureValue"
                                         autocomplete="off" label=" signatureValue:" outlined dense>
                                        <template v-slot:prepend>
                                         <i style="font-size: 20px;" class="fa fa-shield"></i>
                                         </template>
                                         </v-text-field>
                                      </v-col>

                                      <v-col cols="12" md="4" sm="4" class="py-0 my-0"> 
                                         <v-text-field id="formdisabledInput" disabled style="font-size:13px;" 
                                              :value="UtilDevolucion.fechafirmadgii" autocomplete="off" label="fechafirmadgii" outlined dense hide-details>
                                              <template v-slot:prepend>
                                              <i style="font-size: 20px;" class="fa fa-calendar"></i>
                                              </template>
                                           </v-text-field>
                                      </v-col>

                                      <v-col cols="12" md="6" sm="6" > 
                                            <v-textarea autocomplete="off" label="QR:"  dense outlined hide-details
                                              :value="UtilDevolucion.qrdgii" id="formdisabledInput" disabled auto-grow rows="1" >
                                              <template v-slot:prepend>
                                                <i style="font-size: 20px;" class="fa fa-commenting"></i>
                                              </template>
                                            </v-textarea>
                                          </v-col>

                                          <v-col cols="12" md="6" sm="6" > 
                                            <v-textarea autocomplete="off" label="trackId:"  dense outlined hide-details
                                              :value="UtilDevolucion.trackId" id="formdisabledInput"  auto-grow rows="1" >
                                              <template v-slot:prepend>
                                                <i style="font-size: 20px;" class="fa fa-commenting"></i>
                                              </template>
                                            </v-textarea>
                                          </v-col>

         <v-col cols="12" md="6" sm="6"> 
<pre style="font-size: 10px;">
  AMBIENTE:(testecf/certecf/ecf)
  CONSULTA:
  1- https://ecf.dgii.gov.do/{AMBIENTE}/consultaresultado/help/index.html
  2- https://ecf.dgii.gov.do/{AMBIENTE}/consultaestado/help/index.html
</pre>

        
        

        </v-col>                                 



                    </v-row>
                  </v-col>
                <!-- FINcuerpo FACTURACION ELETRONICA -->

               </v-card>

              </v-col>  
               <!-- fn DEVOLUCION Electronica -->

            <!-- cuerpo DEVOLUCION ELETRONICA -->
                  <v-col cols="12" md="12" sm="12">
                    <v-row>
                      <v-col cols="12" md="2" sm="2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            dense
                            outlined
                            type="date"
                            label="Fecha"
                            v-model="UtilDevolucion.fecha"
                            :rules="[$rules.required]"
                            placeholder=" "
                            style="font-size: 12px"
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 16px" class="fa fa-calendar"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se muestra la fecha de la factura de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="4" sm="4">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-combobox
                            id="ImputColorDisable"
                            v-on="on"
                            v-model="UtilDevolucion.documentoinventario"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos:"
                            item-text="descripcion"
                            :rules="[$rules.required]"
                            disabled
                            style="font-size: 13px"
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se muestra el documento de la Devolucion de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                     <v-col cols="12" md="2" sm="2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            id="ImputColorDisable"
                            label="No.Devolucion:"
                            dense
                            autocomplete="off"
                            outlined
                            :rules="[$rules.required]"
                            v-model.number="UtilDevolucion.devoclucionPK.secuencia"
                            style="font-size: 13px"
                            disabled
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-hashtag"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se muestra el número de la devolucion.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="4" sm="4">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            id="ImputColorDisable"
                            v-on="on"
                            label=" NCF:"
                            dense
                            outlined
                            v-model="UtilDevolucion.ncf"
                            placeholder=" "
                            style="font-size: 13px"
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-barcode"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se muestra el número de comprobante fiscal de la factura de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                          id="ImputColorDisable"
                            v-on="on"
                            label="Valor:"
                            dense
                            outlined
                            autocomplete="off"
                            v-model.number="UtilDevolucion.valor"
                            :rules="[$rules.Numericc]"
                            disabled
                            style="font-size: 13px"
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 20px" class="fa fa-money"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se muestra el valor de la devolucion.</span>
                        </i>
                      </v-tooltip>

                    </v-col>

                     <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                          id="ImputColorDisable"
                            v-on="on"
                            label="Valor Itbis:"
                            dense
                            outlined
                            autocomplete="off"
                            v-model.number="UtilDevolucion.valorItbis"
                            :rules="[$rules.Numericc]"
                            disabled
                            style="font-size: 13px"
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 20px" class="fa fa-money"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se muestra el valor Itbis de la devolucion.</span>
                        </i>
                      </v-tooltip>

                    </v-col>

                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0">
 <div style="border: 1px solid #000000;" >
   <v-col style="background-color:#BDBDBD;" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
   <span><b>Detalle Devolución</b></span>
</v-col>
<v-data-table
      class="RowSelectColor elevation-1 RowSelectColor TbSize12"
       item-key="indx"
       :footer-props="$arrayPropiedasesGlobal"
      :headers="[
                 { text: 'COD.PRODUCTO', sortable: false, value: 'producto.codigo', width:120, class: ['no-gutters black--text']  },
                 { text: 'COD.UNIDAD', sortable: false, value: 'unidad.codigo', width:120, class: ['no-gutters black--text']  },
                 { text: 'DESCRIPCIÓN', sortable: false, value: 'desc', width:250, class: ['no-gutters black--text']  },
                 { text: 'CANTIDAD', sortable: false, value: 'cantidad', width:'auto', class: ['no-gutters black--text'] },
                 { text: 'PRECIO', sortable: false, value: 'precio', width:'auto', class: ['no-gutters black--text'] },
                 { text: 'ITBIS(VALOR)', sortable: false, value: 'valorimpuesto', width:'auto', class: ['no-gutters black--text'] },
                 { text: 'DESCUENTO(VALOR)', sortable: false, value: 'valordescuento', width:'auto', class: ['no-gutters black--text'] },
                 { text: 'VALOR', sortable: false, value: 'valor', width:'auto', class: ['no-gutters black--text'] },
                 ]"
              dense
              :items="UtilDevolucion.devolucionDetalleList"  
              :search="search"
              :items-per-page="10"
            >

            <template v-slot:item.desc="props">
            <span style="font-size:13px;"> {{props.item.producto.descripcion }} <b>{{ props.item.unidad.descripcion }}</b> </span>
          </template>

            <template v-slot:item.precio="props">
           <span>{{currencyFormatter(props.item.precio)}}</span>
          </template>

          <template v-slot:item.valordescuento="props">
           <span>{{currencyFormatter(props.item.valordescuento )}}</span>
          </template>

          <template v-slot:item.valorimpuesto="props">
           <span>{{currencyFormatter(props.item.valorimpuesto )}}</span>
          </template>

          <template v-slot:item.valor="props">
            <span style="font-size:12px; display:none;">{{props.item.indx = listDatos.indexOf(props.item)}}</span>
           <span>{{currencyFormatter(props.item.valor )}}</span>
          </template>


          
</v-data-table>
 </div>
                    </v-col>

                    </v-row>
                  </v-col>
                <!-- FINcuerpo DEVOLUCION ELETRONICA -->

  </div>
</v-card>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->
<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
</div>
<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <ComponentsPvImprecionViewer ref="RefPvImprecionViewer" />
</div>


  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import BarraBusqueda2 from "../components/BarraBusquedaDinam";
import VueAutonumeric from "../components/AutoNumericNuevo"
import ContenidoBase from "../components/ContenidoBase";
import {currencyFormatter,FormatoFecha,HoraFormatter,fechaNueva} from "@/js/Funciones.js";
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import ComponentsPvImprecionViewer from "@/PuntodeVenta/UtilidadComponents/PvImprecionViewer.vue";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    VueAutonumeric,
    PvDgiiFacturacionEletronica,
    ComponentsPvImprecionViewer
  },

  created() {
    var json = {
      titulo: "Inventario Físico",
      descripcion: "Inventario Físico",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi:false,
      
      accion: [
        "UtilDevolucionNew",
        "UtilDevolucionSave",
        "UtilDevolucionRemove",
        "UtilDevolucionAnular",
        "UtilDevolucionPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("UtilDevolucionNew", this.new);
    // EventBus.$on("UtilDevolucionSave", this.save);
    // EventBus.$on("UtilDevolucionRemove", this.remove);
    // EventBus.$on("UtilDevolucionAnular", this.remove);
    // EventBus.$on("UtilDevolucionPrintList", this.imprimirList);
    EventBus.$on("emitUtilDevolucion", this.datostabla);
    EventBus.$on("onResize", this.onResize);
  },

  data:()=>  ({


      selected:[],
      listDatos:[],
      windowSize:{width:"auto", height:"auto"},
      TotalRegistros: 1,
      resertPagi: true,
      paginator: {
        itemsPerPage: 15,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      busquedaDevolucion: {
        fechaInicial: fechaNueva(),
        fechaFinal:fechaNueva(),
        opcion:0,
        NoDevolucion:0,
        ncf:'',
        buscarTrackId:''
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },

      UtilDevolucion:null,

totales:{
  costo:0,
  cantidad:0,
  valor:0
},



EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:true,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },

      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
currencyFormatter,FormatoFecha,HoraFormatter,fechaNueva,
onResize(e){
// this.windowSize=e
},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
    
    save() { },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() {},
    newwnuevo() {
     this.UtilDevolucion = null,

     this.selected=[]
     this.listDatos=[]
     this.TotalRegistros= 1
     this.resertPagi= true
      this.paginator= {
        itemsPerPage: 15,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      this.busquedaDevolucion= {
        fechaInicial: fechaNueva(),
        fechaFinal:fechaNueva(),
        opcion:0,
        NoDevolucion:0,
        ncf:'',
        buscarTrackId:''
      },

      this.UtilDevolucion=null,

        EventBus.$emit("actualizaBarraBusqueda2");
    },


BlurDesde(){
if(this.busquedaDevolucion.fechaInicial.toString().length==0){
  this.busquedaDevolucion.fechaInicial=new Date().toISOString().substr(0,10)
}

 },


 BlurHasta(){

if(this.busquedaDevolucion.fechaFinal.toString().length==0){
  this.busquedaDevolucion.fechaFinal=new Date().toISOString().substr(0,10)
}

 },



 getDevolucion() {
        // if(this.busquedaDevolucion.NoFactura.length==0){this.busquedaDevolucion.NoFactura=0}

        if(this.$store.getters.GetdatosInfUsu==null){
        return
        }
        if (
          (this.busquedaDevolucion.NoDevolucion != null && this.busquedaDevolucion.NoDevolucion.length == 0) ||
          this.busquedaDevolucion.NoDevolucion == 0
        ) {
          this.busquedaDevolucion.NoDevolucion = null
        }
        if (this.busquedaDevolucion.ncf != null && this.busquedaDevolucion.ncf.length == 0) {
          this.busquedaDevolucion.ncf = null
        }

        if (this.$refs.formDevolucion.validate()) {
  
          var obj = JSON.parse(JSON.stringify(this.busquedaDevolucion))
          if (this.busquedaDevolucion.documento != null) {
            obj.documento = this.busquedaDevolucion.documento.codigo
          }

          obj.limit = this.paginator.itemsPerPage
          obj.ultimo = this.paginator.pageStart

          this.$axios
            .post(this.$hostname + this.$hName + "/utilitarioDevolucion/consultaDevolucion", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
       
              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listDatos = res.data.ListItems)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },

 obtenerDatoSelect(e) {
        this.datostabla(e.item)
      },


      datostabla(e) {
        console.log('datostabla-->',e)
        var eftc = JSON.parse(JSON.stringify(e))
         eftc.fecha= eftc.nuevaFecha

        this.selected = []
        this.selected.push(JSON.parse(JSON.stringify(e)))
        this.UtilDevolucion = eftc

  
      },


 KeyUpCantidad(e) {
        //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

        if (e.target.value.length == 0) {
          e.target.value = 0
        }

        if (e.key) {
          var mynumeral = require("numeral")
          e.target.value = mynumeral(e.target.value).value()

          //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
          if (e.target.value == null) {
            e.target.value = 0
          }
        } else {
          e.key = ""

          //console.log("no se puede poner letras o signos")
        }

        if (e.target.value.length == 0) {
          e.target.value = 0
          e.key = 0
        }
      },


 resertPaginacion() {
        this.resertPagi = false

        this.paginator.page = 1
        this.paginator.pageStart = 0
        this.paginator.pageStop = this.paginator.itemsPerPage

        var _this = this
        setTimeout(function () {
          _this.resertPagi = true
        }, 500)

        //setTimeout(this.resertPagi=true,1500);
      },

cargarPaginacion(e) {
        this.selected = []
        // console.log('cargarPaginacion')
        //     console.log(e);
        this.paginator = e

        if (this.paginator.itemsPerPage == -1) {
          this.paginator.itemsPerPage = 15
          // this.paginator.itemsPerPage.push(15)
        }

        this.getDevolucion()
        //   this.filtro();
      },

 activarModuloEletronica(DEV){
var BOOL_ACTIVA=false;
      if(DEV!=null){
            var activaSucursal = (DEV.facturasventa.hasOwnProperty('sucursal')&& DEV.facturasventa.sucursal!=null && DEV.facturasventa.sucursal.facturacionEletronica==true)
            if(DEV!=null && DEV.facturasventa.hasOwnProperty('signatureValue') && DEV.facturasventa.signatureValue!=null && DEV.facturasventa.signatureValue.trim().length>0 && DEV.devoclucionPK.secuencia>0 && activaSucursal==true){
              BOOL_ACTIVA=true
            }
            return BOOL_ACTIVA;
      }else{
        return BOOL_ACTIVA;
      }
        
      },

async DevolucionEletronicaGet(FACT){

  var CodigoModificacion=1;
var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_DEV(FACT,CodigoModificacion);



if(resObjCompleto.objtrackId.estado==="Rechazado"){
  var msj_Error=""
  
  Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => { 
    msj_Error+=` *- COD:${element.codigo} :${element.valor} \n`
  }));

  this.alerta(msj_Error, "error")


   if(!FACT.hasOwnProperty('trackId') || FACT.hasOwnProperty('trackId') && FACT.trackId==null || FACT.trackId!=null && !FACT.trackId.includes("estado")){
          this.actualizarFAC_ELETRONICA(FACT, resObjCompleto)
        }
    return
}
//this.enviarImprimirFactura(FACT)
this.actualizarDEV_ELETRONICA(FACT,resObjCompleto)

},

actualizarDEV_ELETRONICA(FACT,objCompTrackId){
  var TRACK =objCompTrackId.objtrackId
  //delete TRACK["mensajes"]
  
  var objTrack={
    documento:FACT.devoclucionPK.documento,
    secuencia:FACT.devoclucionPK.secuencia,
    fechafirmadgii:objCompTrackId.fechafirmadgii,
    qrdgii:objCompTrackId.qrdgii,
    signatureValue:objCompTrackId.signatureValue,
    trackId:JSON.stringify(TRACK)
  }
  
if(FACT.hasOwnProperty('notacreditoclientes')&& FACT.notacreditoclientes!=null){
      this.actualizarNOTA_CreditoCxC_ELETRONICA(FACT.notacreditoclientes, objCompTrackId)
    }
  this.$axios.post(this.$hostname + this.$hName + "/devolucion/actualizarDevolicionEletronica",
  objTrack,{ headers: this.$store.getters.GetheadersAxios })
            .then((res) => {
              if(objCompTrackId.objtrackId.estado==="Aceptado"){
                this.devolucion = res.data
             // this.cancelarAceptarDevolucion()
              this.enviarImprimirDevolucion(res.data)
              }

               if(objCompTrackId.objtrackId.estado==="Aceptado Condicional"){
                this.devolucion = res.data
             //this.cancelarAceptarDevolucion()
              this.enviarImprimirDevolucion(res.data)
              }

            })
            .catch((error) => {
              console.log("actualizartoken no guardado correctamente-->",error)
            });

},

enviarImprimirDevolucion(DEV){

  DEV.caja=0
  var Config = this.$store.getters.GetConfiguracionGeneral
/**/var _this = this;
setTimeout(function () { 
  _this.alerta("Devolucion salvada correctamente !!!", "bien");
            if (localStorage.printerSelect != null) { }
            var selectImpre=(localStorage.printerSelect!=undefined?JSON.parse(localStorage.printerSelect):null)
            var impresora=null
            if(selectImpre!=null && selectImpre.hasOwnProperty('nombre')){
              impresora=JSON.parse(localStorage.printerSelect).nombre
              }
              var msg = {
                accion: "print",
                formato: DEV.facturasventa.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: Config,
                devolucion: DEV,
                caja: DEV.facturasventa.caja,
                cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
              };
              _this.imprimir(msg, "devolucion");
            _this.newwnuevo();
}, 100);

},


 // Envío de una solicitud POST al servidor con los datos a imprimir.
    imprimir(datos, operacion) {

      datos.operacion = operacion;
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      if (datos.formato.trim() === "rolloBlue") {
if(datos.operacion.trim()==="factura"){
var FACT=datos.fac.hasOwnProperty('factura')? datos.fac.factura.factura:datos.fac
var _this = this;
setTimeout(function () {
  _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
  // _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(datos.fac.factura.factura)
}, 800);
       
}

      }else{
        if(datos.impresora==null){
          this.alerta(" seleccione la impresora","error")
          return
        }

        if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
           // this.newwnuevo();;
          })
          .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
          }else{
            //this.cancelarUltimoDocumento();
            //this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
        .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
           // this.newwnuevo();
          })
          .catch((error) => {
            console.error(error)
            this.ejecucion=true 
          });
      }

      }

      
    },



async DevolucionEletronicaGetNoImprecion(FACT){
console.log('GetNoImpre--->',FACT)
/*
 <xs:simpleType name="CodigoModificacionType">
    <xs:restriction base="xs:integer">
      <xs:enumeration value="1"/> <!--Anula el NCF modificado-->
      <xs:enumeration value="2"/> <!--Corrige Texto del Comprobante Fiscal modificado -->
      <xs:enumeration value="3"/> <!--Corrige montos del NCF modificado-->
      <xs:enumeration value="4"/> <!--Reemplazo NCF emitido en contingencia-->
      <xs:enumeration value="5"/> <!--Referencia Factura Consumo Electrónica-->
    </xs:restriction>
  </xs:simpleType>
 */

var CodigoModificacion=1;
if(FACT.facturasventa.activada=true){
  var CodigoModificacion=3;
}

  var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_DEV(FACT,CodigoModificacion);



if(resObjCompleto.objtrackId.estado==="Rechazado"){
  var msj_Error=""
  
  Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => { 
    msj_Error+=` *- COD:${element.codigo} :${element.valor} \n`
  }));

  this.alerta(msj_Error, "error")
  this.actualizarDEV_ELETRONICA_NoImprecion(FACT,resObjCompleto)
return resObjCompleto
}
//this.enviarImprimirFactura(FACT)
this.actualizarDEV_ELETRONICA_NoImprecion(FACT,resObjCompleto)
return resObjCompleto
},

actualizarDEV_ELETRONICA_NoImprecion(FACT,objCompTrackId){
  var TRACK =objCompTrackId.objtrackId
  //delete TRACK["mensajes"]
  
  var objTrack={
    documento:FACT.devoclucionPK.documento,
    secuencia:FACT.devoclucionPK.secuencia,
    fechafirmadgii:objCompTrackId.fechafirmadgii,
    qrdgii:objCompTrackId.qrdgii,
    signatureValue:objCompTrackId.signatureValue,
    trackId:JSON.stringify(TRACK)
  }

  if(FACT.hasOwnProperty('notacreditoclientes')&& FACT.notacreditoclientes!=null){
      this.actualizarNOTA_CreditoCxC_ELETRONICA(FACT.notacreditoclientes, objCompTrackId)
    }

  this.$axios.post(this.$hostname + this.$hName + "/devolucion/actualizarDevolicionEletronica",
  objTrack,{ headers: this.$store.getters.GetheadersAxios })
            .then((res) => {
              if(objCompTrackId.objtrackId.estado==="Aceptado"){
                this.devolucion = res.data
             // this.cancelarAceptarDevolucion()
              //this.enviarImprimirDevolucion(res.data)
              }

               if(objCompTrackId.objtrackId.estado==="Aceptado Condicional"){
                this.devolucion = res.data
             //this.cancelarAceptarDevolucion()
              //this.enviarImprimirDevolucion(res.data)
              }
              this.newwnuevo();

            })
            .catch((error) => {
              console.log("actualizartoken no guardado correctamente-->",error)
            });

},

actualizarNOTA_CreditoCxC_ELETRONICA(FACT, objCompTrackId) {
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.notacreditoclientesPK.documento,
        secuencia: FACT.notacreditoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }


      this.$axios.post(this.$hostname + this.$hName + "/notacreditocliente/actualizarFactEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          console.log('.ACT')
        })
        .catch((error) => {
          console.log("actualizartoken no guardado correctamente-->", error)
        })

    },


alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {},




  },

computed:{

    ActDescBtn(){

this.windowSize=JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize)) 

    }
  }

};
</script>

<style></style>
